module.exports = function() {
  return new Worker(__webpack_public_path__ + "d9f68b2f4ef857c9049d.worker.js");
};